exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--1J3hU {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.wrapper--1J3hU .role-accesses--iRgqf {\n  -ms-flex-preferred-size: 50%;\n      flex-basis: 50%;\n}\n\n.wrapper--1J3hU .role-accesses--iRgqf .content--3TlPx {\n  padding: 5px 0;\n}\n\n.wrapper--1J3hU .role-accesses--iRgqf .role-access--_DxtL {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px 0;\n}\n\n.wrapper--1J3hU .role-accesses--iRgqf .role-access--_DxtL .role-name--1AaM6 {\n  margin-right: 10px;\n}\n\n.wrapper--1J3hU .user-accesses--1Oerv {\n  -ms-flex-preferred-size: 50%;\n      flex-basis: 50%;\n}\n\n.wrapper--1J3hU .user-accesses--1Oerv .content--3TlPx {\n  padding: 5px 0;\n}\n\n.wrapper--1J3hU .user-accesses--1Oerv .user-access--3Md90 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 5px 0;\n}\n\n.wrapper--1J3hU .label--2HVZb {\n  max-width: initial;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--1J3hU",
	"role-accesses": "role-accesses--iRgqf",
	"content": "content--3TlPx",
	"role-access": "role-access--_DxtL",
	"role-name": "role-name--1AaM6",
	"user-accesses": "user-accesses--1Oerv",
	"user-access": "user-access--3Md90",
	"label": "label--2HVZb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/list-items/ProcessingUser/ProcessingUserAccesses/ProcessingUserAccesses.m.scss
// module id = 1576
// module chunks = 0